import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import "./topbar.scss";
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedProjectBackLogId } from '../../common/Redux/Reducer';
import { ModelPageContext } from '../../context/ModelPageContext';

const NavDropdownLinks = ({ disabled = false, title = '', icon: Icon = null, linkUrl = '#' }) => {
    const [gallery, setGallery] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const modal = useContext(ModelPageContext);
    const { Projects } = useSelector((state) => state.ProjamAppSlice);
    let projectId = Projects?.selectedProject?.selectedProjectData?._id;
    const NavProjectsList = Projects?.allProjectsList?.data?.filter(project => project.active !== "false");

    const isProjects = title === "Projects";
    // inside a project (but not the profile page, which also lives under /projects)
    const isActive = isProjects
        ? /^\/projects\/(?!profile(\/|$))[^/]+/.test(location.pathname)
        : location.pathname.includes(linkUrl);

    const handleClick = (event) => {
        setGallery(event.currentTarget);
    };

    const handleClose = () => {
        setGallery(null);
    };
    const open = Boolean(gallery);

    const handleCreateProject = () => {
        setGallery(null);
        modal?.setModalState?.({ open: true, createProject: true });
    };

    const handleMenuItemClick = (selectedId) => {
        const project = NavProjectsList?.find((proj) => proj._id === selectedId);

        if (project && project.backlogs && project.backlogs.length > 0) {
            const backlogId = project.backlogs[0];
            const selectedProjectDetails = {
                projectId: selectedId,
                backlogId: backlogId,
                projectName: project.title
            };

            dispatch(setSelectedProjectBackLogId({ id: backlogId }));
            setGallery(null);

            document.querySelectorAll('.MenuItem').forEach(item => {
                item.classList.remove('active');
            });
            document.getElementById(selectedId)?.classList.add('active');
            navigate(`/projects/${project?.slugString}/active-sprints`, { state: { queryParams: selectedProjectDetails } });
        } else {
            console.error("No backlog found for this project");
        }
    };

    return (
        <div className='nav-dropdown-links'>
            <Button
                onClick={handleClick}
                className={`tb-nav-btn ${isActive ? 'active' : ''} ${open ? 'is-open' : ''}`}
                startIcon={Icon ? <Icon /> : null}
                endIcon={isProjects ? <KeyboardArrowDownRoundedIcon className="tb-nav-btn__chevron" /> : null}
                disabled={Boolean(disabled)}
                disableRipple
                aria-haspopup={isProjects ? 'menu' : undefined}
                aria-expanded={isProjects ? open : undefined}
            >
                {title}
            </Button>
            {isProjects && (
                <Menu
                    anchorEl={gallery}
                    open={open}
                    onClose={handleClose}
                    className="projects-menu"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    slotProps={{ paper: { className: 'tb-menu tb-projects-menu' } }}
                >
                    <div className="tb-menu__label" tabIndex={-1}>Switch project</div>
                    {/* only the project list scrolls, so "Create project" stays reachable */}
                    <div className="tb-projects-menu__list">
                        {NavProjectsList && NavProjectsList.length > 0 ? (
                            NavProjectsList.map((project, index) => {
                                const isCurrent = projectId === project._id && location.pathname !== '/projects';
                                return (
                                    <MenuItem
                                        component="div"
                                        id={project._id}
                                        key={project._id}
                                        onClick={() => handleMenuItemClick(project._id)}
                                        className={`nav-menu-item tb-menu__item ${isCurrent ? 'active-menu-link-item-cls is-current' : ''}`}
                                        style={{ '--i': index }}
                                    >
                                        <span className="tb-menu__text">{project.title}</span>
                                        {isCurrent ? <CheckRoundedIcon className="tb-menu__check" /> : null}
                                    </MenuItem>
                                );
                            })
                        ) : (
                            <MenuItem disabled className="no-projects-assigned tb-menu__item">
                                No projects assigned
                            </MenuItem>
                        )}
                    </div>

                    <div className="tb-projects-menu__foot">
                        <MenuItem
                            component="div"
                            onClick={handleCreateProject}
                            className="tb-menu__item is-accent tb-menu__item--create"
                        >
                            <span className="tb-menu__icon"><AddRoundedIcon /></span>
                            <span className="tb-menu__text">Create project</span>
                        </MenuItem>
                    </div>
                </Menu>
            )}
        </div>
    );
};

export default NavDropdownLinks;
